import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import { t } from "../../../core/translate";
import { styledMedia } from "../../../components/mediaquery/breakpoints";
import NullExploreGraphic from "../../../components/icons/NullExploreGraphic";
import { selectors as routerSelectors } from "../../../../redux/router";
import { Button } from "@vitalsource/vstui";

const StyledNullScreen = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  ${styledMedia.small`
		padding: 0 45px;
  `}
`;

const HeadingBlockParagraph = styled.p`
  display: flex;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: 500;
  padding: 0 0 35px 0;
  width: 100%;
`;

const ConstructionContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  svg {
    max-width: 805px;
    height: 430px;
    ${styledMedia.small`
			max-height: 300px;
  	`}
  }
`;

const LibraryNullScreen = ({ search }) => {
  return (
    <StyledNullScreen>
      <ConstructionContainer className="build-explore">
        <NullExploreGraphic />
      </ConstructionContainer>
      <HeadingBlockParagraph>
        {t(
          "explorer.explore-null-text",
          "Nothing here! Go to My Library to see your books."
        )}
      </HeadingBlockParagraph>
      <Button href={`/#/${search}`}>
        {t("explorer.empty-button", "Go to My Library")}
      </Button>
    </StyledNullScreen>
  );
};

const mapStateToProps = state => ({
  search: routerSelectors.getSearch(state)
});

export default withTheme(connect(mapStateToProps)(LibraryNullScreen));
